<template>
  <!---------Start Of Page Content--------->
  <div>
    <!------Start Of Bread crumb------------>
    <section class="about-header section-bg-4 mt-0"> <!---- :style="{ marginTop: activePromotion ? '0' : '64px' }" -->
      <div class="container">
        <h1>{{ $t('verifyCertificate') }}</h1>
      </div>
    </section>
    <!-------End Of Bread crumb ------->
    <div class="container">
      <div class="row pt-60 pb-50" v-if="verified">
        <div class="mx-auto verify-certificate-1">
          <!---start of verify form-------->
          <section class="pt-35 px-40 pb-35">
            <div class="certificate-wrapper ">
              <div class="certificate-header mb-4 text-center">
                <h2 class="user-name mb-3">{{ traineeData }}</h2>
                <p class="sectionTitle__text fs-5"> <span class="fw-bold">{{ $t('course-name') }} </span> : {{
                  courseName
                  }}</p>
              </div>

              <div class="certificate-body">
                <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="550px" frameborder="0"
                  class="rounded border"></iframe>
              </div>
            </div>

            <div class="mt-60">
              <div class="d-flex align-items-center justify-center gap-15 flex-md-row flex-column">
                <router-link to="/courses"
                  class="d-inline-flex justify-center align-items-center gap-2 main-button rotate-svg"
                  aria-label="explore">
                  <span> {{ $t("button2") }} </span>
                  <span class="rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M15.586 10.657L11.636 6.70704C11.4538 6.51844 11.353 6.26584 11.3553 6.00364C11.3576 5.74144 11.4628 5.49063 11.6482 5.30522C11.8336 5.11981 12.0844 5.01465 12.3466 5.01237C12.6088 5.01009 12.8614 5.11088 13.05 5.29304L18.707 10.95C18.8002 11.0427 18.8741 11.1529 18.9246 11.2742C18.9751 11.3955 19.001 11.5256 19.001 11.657C19.001 11.7884 18.9751 11.9186 18.9246 12.0399C18.8741 12.1612 18.8002 12.2714 18.707 12.364L13.05 18.021C12.9578 18.1166 12.8474 18.1927 12.7254 18.2451C12.6034 18.2976 12.4722 18.3251 12.3394 18.3263C12.2066 18.3274 12.0749 18.3021 11.952 18.2519C11.8291 18.2016 11.7175 18.1273 11.6236 18.0334C11.5297 17.9395 11.4555 17.8279 11.4052 17.705C11.3549 17.5821 11.3296 17.4504 11.3307 17.3176C11.3319 17.1849 11.3595 17.0536 11.4119 16.9316C11.4643 16.8096 11.5405 16.6993 11.636 16.607L15.586 12.657H6C5.73478 12.657 5.48043 12.5517 5.29289 12.3641C5.10536 12.1766 5 11.9223 5 11.657C5 11.3918 5.10536 11.1375 5.29289 10.9499C5.48043 10.7624 5.73478 10.657 6 10.657H15.586Z"
                        fill="white" />
                    </svg>
                  </span>
                </router-link>
                <router-link to="/contact"
                  class="d-inline-flex justify-center align-items-center gap-2 main-button main-button-2 rotate-svg"
                  aria-label="popular">
                  <span> {{ $t('contactSupport') }} </span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                        fill="#94AD04" />
                    </svg>
                  </span>
                </router-link>
              </div>
            </div>
          </section>
          <!------end of verify form------------->
        </div>
      </div>
      <!------start of Verification step------------>
      <div class="row pt-60 pb-50" v-else>
        <div class="mx-auto verify-certificate-1">
          <!---start of verify form-------->
          <section class="pt-35 px-40 pb-35">
            <div class="mb-30">
              <div class="sectionTitle">
                <h2 class="sectionTitle__title">{{ $t('verifyCertificate') }}</h2>
                <p class="sectionTitle__text">
                  {{ $t('enterCertificateDetails') }}
                </p>
              </div>
            </div>

            <form class="mt-50" @submit.prevent="submitForm">
              <input type="text" v-model.trim="certificateId" @input="invalid = false"
                :placeholder="$t('CertificateID')"
                class="form-control rounded-8 pt-15 pb-15 pr-30 pl-30 border-1 border-dark-1-lg" style="width: 100%" />

              <div class="alert alert-danger my-2" v-if="invalid">
                {{ $t('enterCertificateId') }}
              </div>

              <div class="alert alert-danger my-2" v-if="serverError">
                {{ serverError }}
              </div>

              <div class="d-flex justify-content-center mt-4 w-100">
                <button class="main-button capitalize w-75 rotate-svg d-flex align-items-center justify-content-center"
                  type="submit" :disabled="isLoading" :class="{ 'bg-secondary text-white': isLoading }">
                  <template v-if="isLoading">
                    <div class="spinner-border text-warning me-2" role="status" style="width: 1.2rem; height: 1.2rem;">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </template>
                  <template v-else>
                    {{ $t('verifyButton') }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path
                        d="M16.086 10.6569L12.136 6.70692C11.9538 6.51832 11.853 6.26571 11.8553 6.00352C11.8576 5.74132 11.9628 5.49051 12.1482 5.3051C12.3336 5.11969 12.5844 5.01452 12.8466 5.01224C13.1088 5.00997 13.3614 5.11076 13.55 5.29292L19.207 10.9499C19.3002 11.0426 19.3741 11.1527 19.4246 11.2741C19.4751 11.3954 19.501 11.5255 19.501 11.6569C19.501 11.7883 19.4751 11.9184 19.4246 12.0398C19.3741 12.1611 19.3002 12.2713 19.207 12.3639L13.55 18.0209C13.4578 18.1164 13.3474 18.1926 13.2254 18.245C13.1034 18.2974 12.9722 18.325 12.8394 18.3262C12.7066 18.3273 12.5749 18.302 12.452 18.2517C12.3291 18.2015 12.2175 18.1272 12.1236 18.0333C12.0297 17.9394 11.9555 17.8278 11.9052 17.7049C11.8549 17.582 11.8296 17.4503 11.8307 17.3175C11.8319 17.1847 11.8595 17.0535 11.9119 16.9315C11.9643 16.8095 12.0405 16.6992 12.136 16.6069L16.086 12.6569H6.5C6.23478 12.6569 5.98043 12.5516 5.79289 12.364C5.60536 12.1765 5.5 11.9221 5.5 11.6569C5.5 11.3917 5.60536 11.1373 5.79289 10.9498C5.98043 10.7623 6.23478 10.6569 6.5 10.6569H16.086Z"
                        fill="white" />
                    </svg>
                  </template>
                </button>

                <!-- <button class="main-button capitalize w-75 rotate-svg" id="openModal" type="submit">
                  {{ $t('verifyButton') }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M16.086 10.6569L12.136 6.70692C11.9538 6.51832 11.853 6.26571 11.8553 6.00352C11.8576 5.74132 11.9628 5.49051 12.1482 5.3051C12.3336 5.11969 12.5844 5.01452 12.8466 5.01224C13.1088 5.00997 13.3614 5.11076 13.55 5.29292L19.207 10.9499C19.3002 11.0426 19.3741 11.1527 19.4246 11.2741C19.4751 11.3954 19.501 11.5255 19.501 11.6569C19.501 11.7883 19.4751 11.9184 19.4246 12.0398C19.3741 12.1611 19.3002 12.2713 19.207 12.3639L13.55 18.0209C13.4578 18.1164 13.3474 18.1926 13.2254 18.245C13.1034 18.2974 12.9722 18.325 12.8394 18.3262C12.7066 18.3273 12.5749 18.302 12.452 18.2517C12.3291 18.2015 12.2175 18.1272 12.1236 18.0333C12.0297 17.9394 11.9555 17.8278 11.9052 17.7049C11.8549 17.582 11.8296 17.4503 11.8307 17.3175C11.8319 17.1847 11.8595 17.0535 11.9119 16.9315C11.9643 16.8095 12.0405 16.6992 12.136 16.6069L16.086 12.6569H6.5C6.23478 12.6569 5.98043 12.5516 5.79289 12.364C5.60536 12.1765 5.5 11.9221 5.5 11.6569C5.5 11.3917 5.60536 11.1373 5.79289 10.9498C5.98043 10.7623 6.23478 10.6569 6.5 10.6569H16.086Z"
                      fill="white" />
                  </svg>
                </button> -->
              </div>
            </form>
          </section>
          <!------end of verify form------------->

          <!-- Modal -->
          <div id="customModal" class="modal" v-if="showModal">
            <div class="modal-content relative">
              <span class="close-btn" id="closeModal" @click="closeModal">&times;</span>
              <div class="d-flex justify-center align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102" fill="none">
                  <g clip-path="url(#clip0_706_19904)">
                    <path
                      d="M102 51C102 53.2313 102 55.1437 101.681 57.375L100.725 63.1125C98.175 73.95 92.1187 83.1937 83.8312 90.2062C83.5125 90.525 82.875 90.8438 82.5563 91.1625C79.6875 93.3938 76.5 95.3063 72.9938 96.9L71.0812 97.8563C68.2125 99.1313 65.6625 100.088 62.475 100.725C60.8813 101.044 59.6063 101.362 58.0125 101.681C55.4625 102 53.2313 102 51 102C22.95 102 0 79.05 0 51C0 22.95 22.95 0 51 0C79.05 0 102 22.95 102 51Z"
                      fill="#EF4639" />
                    <path
                      d="M101.681 57.375L100.725 63.1125C98.175 73.9501 92.1187 83.1938 83.8312 90.2063C83.5125 90.5251 82.875 90.8438 82.5562 91.1626C79.6875 93.3938 76.5 95.3063 72.9937 96.9001L71.0812 97.8563C68.2125 99.1313 65.6625 100.088 62.475 100.725C60.8812 101.044 59.6063 101.363 58.0125 101.681L29.325 72.9938C27.4125 71.0813 27.4125 67.8938 29.325 65.6626L43.9875 51L29.325 36.3375C27.4125 34.425 27.4125 31.2376 29.325 29.0063C31.2375 27.0938 34.425 27.0938 36.6562 29.0063L37.2937 29.6438L38.5688 30.9188L42.7125 35.0625L43.9875 36.3375L48.1313 40.4813L49.4062 41.7563L51.6375 43.9876L65.6625 28.6875C67.575 26.775 70.7625 26.775 72.9937 28.6875L101.681 57.375Z"
                      fill="#E2382F" />
                    <path
                      d="M72.9937 65.3438C74.9062 67.2563 74.9062 70.4438 72.9937 72.675C72.0375 73.6313 70.7625 74.2688 69.4875 74.2688C68.2125 74.2688 66.9375 73.6313 65.9813 72.675L51 58.0126L36.3375 72.675C35.3812 73.6313 34.1063 74.2688 32.8313 74.2688C31.5563 74.2688 30.2812 73.6313 29.325 72.675C27.4125 70.7625 27.4125 67.575 29.325 65.3438L43.9875 50.6813L29.325 36.0188C27.4125 34.1063 27.4125 30.9188 29.325 28.6875C31.2375 26.775 34.425 26.775 36.6563 28.6875L51.3188 43.35L65.6625 28.6875C67.575 26.775 70.7625 26.775 72.9937 28.6875C74.9062 30.6 74.9062 33.7875 72.9937 36.0188L58.3312 50.6813L72.9937 65.3438Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clippath id="clip0_706_19904">
                      <rect width="102" height="102" fill="white" />
                    </clippath>
                  </defs>
                </svg>
              </div>
              <div class="sectionTitle mt-40 justify-center">
                <h2 class="sectionTitle__title">{{ $t('certificateNotFound') }}</h2>
                <p class="sectionTitle__text">
                  {{ $t('furtherAssistance') }}
                </p>
              </div>
              <!------Buttons------------>
              <div class="d-flex align-items-center justify-center gap-15 flex-md-row flex-column mt-40">
                <router-link to="/" class="d-inline-flex justify-center align-items-center gap-2 main-button rotate-svg"
                  id="closeModal2" aria-label="explore">
                  <span> {{ $t('backToHome') }} </span>
                  <span class="rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M15.586 10.657L11.636 6.70704C11.4538 6.51844 11.353 6.26584 11.3553 6.00364C11.3576 5.74144 11.4628 5.49063 11.6482 5.30522C11.8336 5.11981 12.0844 5.01465 12.3466 5.01237C12.6088 5.01009 12.8614 5.11088 13.05 5.29304L18.707 10.95C18.8002 11.0427 18.8741 11.1529 18.9246 11.2742C18.9751 11.3955 19.001 11.5256 19.001 11.657C19.001 11.7884 18.9751 11.9186 18.9246 12.0399C18.8741 12.1612 18.8002 12.2714 18.707 12.364L13.05 18.021C12.9578 18.1166 12.8474 18.1927 12.7254 18.2451C12.6034 18.2976 12.4722 18.3251 12.3394 18.3263C12.2066 18.3274 12.0749 18.3021 11.952 18.2519C11.8291 18.2016 11.7175 18.1273 11.6236 18.0334C11.5297 17.9395 11.4555 17.8279 11.4052 17.705C11.3549 17.5821 11.3296 17.4504 11.3307 17.3176C11.3319 17.1849 11.3595 17.0536 11.4119 16.9316C11.4643 16.8096 11.5405 16.6993 11.636 16.607L15.586 12.657H6C5.73478 12.657 5.48043 12.5517 5.29289 12.3641C5.10536 12.1766 5 11.9223 5 11.657C5 11.3918 5.10536 11.1375 5.29289 10.9499C5.48043 10.7624 5.73478 10.657 6 10.657H15.586Z"
                        fill="white" />
                    </svg>
                  </span>
                </router-link>
                <router-link to="/contact"
                  class="d-inline-flex justify-center align-items-center gap-2 main-button main-button-2 rotate-svg"
                  id="closeModal2" aria-label="popular">
                  <span> {{ $t('contactSupport') }} </span>
                  <span class="rotate-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                        fill="#94AD04" />
                    </svg>
                  </span>
                </router-link>
              </div>
            </div>
          </div>
          <!------------------>
        </div>
      </div>
      <!-------end of verification step------->
    </div>
  </div>
  <!------end of Content------------>
</template>
<script>
import { verifyCertificate } from '@/Services/api/CoursesService'
export default {
  data() {
    return {
      verified: false,
      certificateId: null,
      showModal: false,
      serverError: "",
      pdfUrl: null,
      traineeData: '',
      courseName: '',
      invalid: false,
      isLoading: false,
    };
  },
  methods: {
    async submitForm() {
      if (this.certificateId !== null) {
        try {
          this.isLoading = true;
          const response = await verifyCertificate(this.certificateId);
          this.pdfUrl = response.data.file_url;
          this.traineeData = response.data.user.name;
          this.courseName = response.data.course.title;
          this.showModal = true;
          this.verified = true;
          //this.verified = response.data.options.has_certification
        } catch (error) {
          // this.serverError = error;
          this.showModal = true;
          this.verified = false
        } finally {
          this.isLoading = false
        }
      } else {
        this.invalid = true
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 1.5rem;
  cursor: pointer;
}

.verify-certificate-1 {
  width: 58%;
}

@media screen and (max-width: 992.9px) {
  .verify-certificate-1 {
    width: 80%;
  }
}

@media screen and (max-width: 768.9px) {
  .verify-certificate-1 {
    width: 98%;
  }
}

.user-name {
  color: #00293A
}
</style>
